import { API_BASE_URL } from '../utils/constants';

export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}pegasus/visionary/extras/queries`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        phone_number: formData.phoneNumber,
        comment: formData.message,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    } else {
      return {
        success: false,
        error: data?.message || 'An error occurred. Please try again later.',
      };
    }
  } catch (error) {
    console.error('Contact form submission error:', error);
    return {
      success: false,
      error: 'An error occurred. Please try again later.',
    };
  }
};
